import React, {Component} from 'react';
import {APIClient} from "../../../utils/APIClient";
import {API_URL} from "../../../settings/local_settings";
import {SaveButton} from "../../business_units/SaveButton";
import {Spinner} from "../../Spinner";
import {Button, Input} from "reactstrap";
import {SpinnerSecondaryButton} from "../../SpinnerSecondaryButton";
import {MultiSelect} from "../../selects/MultiSelect";
import {HELP_WEBHOOK, LinkToArticle} from "../../help_center/LinkToArticle";
import { withTranslation } from 'react-i18next';

class WebhookComponentClass extends Component {
    constructor(props) {
        super(props);

        this.handleWebhookChange = this.handleWebhookChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleTest = this.handleTest.bind(this);
        this.handleEventsChange = this.handleEventsChange.bind(this);

        this.state = {
            testing: false,
            loading: true,
            isSaving: false,
            hasChanges: false,
            hasAccessToModule: null,
            webhookUrl: null,
            events: null,
            eventsSelected: null
        };
    }

    getPostData() {
        return {
            "webhook_url": this.state.webhookUrl,
            "events": this.state.eventsSelected
        };
    }

    handleTest() {
        this.setState({testing: true});
        const data = this.getPostData();

        this.testWebhookUrl(data).then((response) => {
            const { t } = this.props;
            if (response.status === 'ERROR') {
                alert(response.error_message);
            } else if (response.status === 'OK') {
                alert(t('webhook_component.test_successful'));
            } else if (response.status === 'NO_MODULE_ACCESS') {
                alert(response.error_message);
            }
            this.setState({testing: false});
        });
    }

    handleSubmit() {

        this.setState({isSaving: true});

        this.postForm(this.getPostData()).then((response) => {
            const { t } = this.props;
            if (response.status === 'ERROR') {
                alert(response.error_message);
            } else if (response.status === 'OK') {
                alert(t('webhook_component.changes_saved_successfully'))
                this.setState({hasChanges: false});
            } else if (response.status === 'NO_MODULE_ACCESS') {
                alert(response.error_message);
            }
            this.setState({isSaving: false});
        });
    }

    postForm(data) {
        const apiClient = new APIClient(this.getWebhookUrl());
        return apiClient.call('PUT', data);
    }

    testWebhookUrl(data) {
        const apiClient = new APIClient(this.getTestWebhookUrl());
        return apiClient.call('PUT', data);
    }

    componentDidMount() {
        this.getAgencyWebhookConfiguration();
    }

    getEvents() {
        // SI la agencia no tiene acceso al modulo, igual traigo los eventos para que vean cuales hay
        new APIClient(this.getEventsUrl()).call('GET').then((data) => {
            if (data.status === 'ERROR_NO_AGENCY') {
                alert(data['error_message']);
                this.redirectToAgencyRegisterPage()
            } else if (data.status === 'OK') {
                const events = data.data !== undefined ? data.data : [];
                this.setState({
                    events: events,
                    loading: false
                });
            } else {
                alert(data['error_message']);
            }
        })
    }

    getAgencyWebhookConfiguration() {
        new APIClient(this.getWebhookUrl()).call('GET').then((data) => {
            if (data.status === 'ERROR_NO_AGENCY') {
                alert(data['error_message']);
                this.redirectToAgencyRegisterPage()
            } else if (data.status === 'NO_MODULE_ACCESS') {
                this.setState({hasAccessToModule: false});
                this.getEvents();
            } else if (data.status === 'OK') {
                const webhookUrl = data.data !== undefined ? data.data["webhook_url"] : null;
                const events = data.data !== undefined ? data.data["events"] : null;
                const eventsSelected = data.data !== undefined ? data.data["events_selected"] : null

                this.setState({
                    webhookUrl: webhookUrl,
                    events: events,
                    eventsSelected: eventsSelected,
                    hasAccessToModule: true,
                    loading: false
                });
            } else {
                alert(data['error_message']);
            }
        })
    }

    getWebhookUrl() {
        return API_URL + 'webhook-url/';
    }

    getTestWebhookUrl() {
        return API_URL + 'webhook-url/test';
    }

    getEventsUrl() {
        return API_URL + 'events';
    }

    handleWebhookChange(event) {
        const target = event.target;

        this.setState({
            webhookUrl: target.value,
            hasChanges: true
        });
    }

    renderSaveButton() {
        const { t } = this.props;
        return <SaveButton text={t('webhook_component.save_button')}
                           isSaving={this.state.isSaving}
                           onClick={this.handleSubmit}
                           hasChanges={this.state.hasChanges}/>
    }

    render() {
        const { t } = this.props;
        return (
            <div className="section-body-item -wider box">
                <header className="box-header">
                    <h2 className="box-title">{t('webhook_component.title')}</h2>
                </header>
                {this.renderInnerComponents()}
            </div>
        )
    }

    renderAccessStatus() {
        const { t } = this.props;
        if (this.state.hasAccessToModule)
            return;

        return <div className="form-row">
            <div className="alert alert-info">
                {t('webhook_component.agency_plan_required')}
            </div>
        </div>
    }

    renderTestButton() {
        if(this.state.testing === true) {
            return <SpinnerSecondaryButton style={{minWidth:"115px"}} className="btn btn-secondary"/>;
        }

        const { t } = this.props;
        return <Button key="button" className="btn btn-secondary" onClick={this.handleTest}  style={{minWidth:"115px"}}>{t('webhook_component.test_button')}</Button>
    }

    renderInnerComponents() {
        if (this.state.loading === true) {
            return <div className="box-loader">
                <Spinner color="positive"/>
            </div>
        }

        const { t } = this.props;
        return [
            <div className="form-row">
                <label>{t('webhook_component.description')}<br/>{t('webhook_component.article_link')}&nbsp;&nbsp;➡️<LinkToArticle article={HELP_WEBHOOK}/></label>
            </div>,
            this.renderAccessStatus(),
            this.renderWebhookComponents(),
            this.renderSaveButton()
        ];
    }

    renderWebhookComponents() {
        const { t } = this.props;
        return <div className="form-row">
            <div className="form-col col-12 mb-3">
                <label>{t('webhook_component.webhook_url_label')}</label>
                <div className="input-group-append">
                    <Input name="webhookUrl" readOnly={false} type="text" value={this.state.webhookUrl}
                           onChange={this.handleWebhookChange} className="form-control mr-2"/>
                    {this.renderTestButton()}
                </div>
            </div>
            <div className="form-col col-6">
                <label>{t('webhook_component.events_to_send_label')}</label>
                <MultiSelect
                    items={this.getEventsOptions()}
                    selectedItemIds={this.getSelectedEventsOptions()}
                    onChange={this.handleEventsChange}
                />
            </div>
        </div>
    }

    getEventsOptions() {
        return this.state.events !== null? this.state.events : [];
    }

    getSelectedEventsOptions() {
        return this.state.eventsSelected !== null? this.state.eventsSelected : [];
    }

    handleEventsChange(eventsSelected) {
        this.setState({
            eventsSelected: eventsSelected,
            hasChanges: true
        })
    }
}

export const WebhookComponent = withTranslation()(WebhookComponentClass);
export default WebhookComponent;
